/**
 * Whether a window's focus has to be put back when the request it sent ends.
 *
 * A button disabled while the request is out drops the focus onto <body>, outside the window. When
 * the answer is a refusal the window is still open, and the focus goes back to the button it left.
 * Only then: a submit sent with Enter from a field leaves the focus in that field, which stays
 * enabled, and nothing is moved.
 */
export function shouldRestoreFocus(state: {
  wasBusy: boolean;
  busy: boolean;
  open: boolean;
  focusInside: boolean;
}): boolean {
  return state.wasBusy && !state.busy && state.open && !state.focusInside;
}
